<template>
    <div class="container">
        <div class="content">
            <div style="text-align: center">
                <van-image
                    style="width: 90%; margin-top: 10px"
                    :src="picUrl + logoUrl"
                    fit="contain"
                />
            </div>
            <div class="tab-wrap">
                <div
                    class="tab"
                    :class="{ active: index == tabIndex }"
                    v-for="(item, index) in tabData"
                    :key="index"
                    @click="tabChange(index)"
                >
                    {{ item }}
                </div>
            </div>
            <div class="tab-content">
                <div v-if="tabIndex == 0">
                    <div class="form-item">
                        <input
                            class="input"
                            placeholder-class="placeholderClass"
                            name="input"
                            placeholder="请输入您的手机号码"
                            v-model="phone"
                            @click="inputShow"
                        />
                    </div>
                    <div class="form-item message">
                        <input
                            class="input"
                            placeholder-class="placeholderClass"
                            name="input"
                            placeholder="请输入验证码"
                            v-model="code"
                            @click="inputShow"
                        />
                        <div class="button" @click="sendMsg">
                            {{ msgSendTxt }}
                        </div>
                    </div>
                    <div class="btn-v">
                        <button class="button" @click="checkUserCardBefore">
                            确定
                        </button>
                    </div>
                </div>
                <div v-if="tabIndex == 1"></div>
            </div>
        </div>
    </div>
</template>

<script>
var md5Code = require("../utils/md5.js");
import request from "../utils/request.js";
import { throttle } from "@/utils/utils";
import qs from "qs";
import md5 from "js-md5";
import Cookies from "js-cookie";
import { checkUserAgent } from "@/utils/checkUserAgent";
import { Toast } from "vant";
export default {
    name: "CardActive",
    components: {},
    mixins: [checkUserAgent],
    data() {
        return {
            logoUrl: "",
            picUrl: "",
            themePicUrl: "",
            tabData: ["在线激活"],
            tabIndex: 0,
            price: 0,
            orderId: "",
            phone: "",
            code: "",
            msgSendStatus: true,
            msgSendTxt: "获取验证码",
            channelId: "",
            openId: "",
            productId: "",
            userAgent: "",
        };
    },
    created() {
        this.picUrlQuery();
        this.init();
    },
    mounted() {
        // this.getProductDetail();
    },
    methods: {
        // 圖片前綴
        picUrlQuery() {
            const that = this;
            request({
                url: "/tour-product/imge/getUrl",
                method: "post",
            })
                .then(function (res) {
                    if (res.data.code != "200") {
                        throw res.data.msg;
                    }
                    if (res.data.code == "200") {
                        that.picUrl = res.data.data;
                        that.themePicUrl =
                            res.data.data + process.env.VUE_APP_PIC_URL;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        init() {
            this.checkUserAgent({
                success: (res) => {
                    this.userAgent = res; // 环境
                    console.log(`环境：${res}，激活卡页`);

                    if (res === "miniprogram") {
                        this.appId = this.$route.query.appId; // 小程序APPID
                    }
                    if (res === "miniprogram" || res === "wechat") {
                        const openId = this.$route.query.openId; // openid
                        if (!openId) {
                            this.openId = "";
                            this.$toast("未获取到openId");
                        } else {
                            this.openId = openId;
                        }
                    }
                    this.channelId = Cookies.get("cykskid"); // 代理商ID
                    this.productId = Cookies.get("productId"); // 卡片ID
                    this.logoUrl = JSON.parse(
                        Cookies.get("productInfo")
                    ).logoUrl; // 卡片图片
                },
            });
        },
        //获取产品详情
        getProductDetail() {
            const that = this;
            try {
                const appId = 1;
                const key = 1112;
                let data = {
                    productId: this.productId,
                };
                // 签名生成
                let sign = "appId=" + appId;
                if (data && Object.keys(data).length > 0) {
                    let newKeys = Object.keys(data).sort();
                    newKeys.forEach((key) => {
                        sign += "&" + key + "=" + data[key];
                    });
                }
                sign += key;
                sign = md5Code.md5(sign).toUpperCase();
                data.sign = sign;
                data.appId = appId;
                request({
                    url: "/tour-product/sysProduct/queryProductDetail",
                    method: "post",
                    params: data,
                })
                    .then(function (res) {
                        if (res.data.code == 200) {
                            console.log(11111);
                            console.log(res.data.data.logoUrl);
                            that.logoUrl = res.data.data.logoUrl;
                        } else {
                            that.$toast(res.data.msg);
                        }
                    })
                    .catch(function (err) {
                        that.$toast(err);
                    });
            } catch (e) {
                console.log(e);
            }
        },
        tabChange(index) {
            this.tabIndex = index;
        },
        back() {
            this.$router.push("/?channelid=" + Cookies.get("cykskid"));
        },
        // 发送短信
        sendMsg() {
            const that = this;
            if (this.phone.length < 1) {
                this.$toast("手机号为空");
                return false;
            } else {
                const reg = /^1[3-9]\d{9}$/g;
                const result = reg.test(this.phone);
                if (!result) {
                    this.$toast("请输入正确格式的手机号");
                    return;
                }
            }
            if (!this.msgSendStatus) {
                return;
            }
            const appId = 1;
            const key = 1112;
            const sortstr =
                "appId=" + appId + "&phone=" + this.phone + "" + key;

            const sign = md5(sortstr).toUpperCase();

            const data = qs.stringify({
                sign: sign,
                appId: appId,
                phone: this.phone,
            });

            request({
                url: "/tour-product/wxuser/sendSms",
                method: "POST",
                data: data,
            })
                .then((res) => {
                    if (res.data.code != "200") {
                        throw res.data.msg;
                    }
                    if (res.data.code == "200") {
                        that.$toast(res.data.msg);
                        let time = 60;
                        (that.msgSendStatus = false),
                            (that.msgSendTxt = time + "秒再试");

                        let timer = setInterval(function () {
                            if (time <= 0) {
                                (that.msgSendStatus = true),
                                    (that.msgSendTxt = "获取验证码");

                                clearInterval(timer);
                                return false;
                            }
                            that.msgSendTxt = time + "秒再试";
                            that.sendStatus = false;
                            time--;
                        }, 1000);
                    }
                })
                .catch((err) => {
                    that.$toast(err);
                });
        },
        // 节流
        checkUserCardBefore: throttle(function () {
            this.checkUserCard();
        }),
        // 购卡检查
        checkUserCard() {
            const that = this;
            if (this.phone.length < 1) {
                this.$toast("手机号为空");
                return false;
            } else {
                const reg = /^1[3-9]\d{9}$/g;
                const result = reg.test(this.phone);
                if (!result) {
                    this.$toast("请输入正确格式的手机号");
                    return;
                }
            }
            if (this.code.length < 1) {
                this.$toast("验证码为空");
                return false;
            }
            let params = {
                productId: this.productId,
                phone: this.phone,
            };
            request({
                url: "/tour-product/wxusercard/checkForBuyCard",
                method: "POST",
                params: params,
            })
                .then((res) => {
                    console.log(res);
                    if (res.data.code == "200") {
                        that.vaildPhone();
                    } else if (res.data.code == "408") {
                        var result = confirm(res.data.msg);
                        if (result == true) {
                            that.vaildPhone();
                        }
                    } else {
                        throw res.data.msg;
                    }
                })
                .catch((err) => {
                    that.$toast(err);
                });
        },
        // 生成订单
        vaildPhone() {
            const that = this;
            const verifyCode = this.code;
            const { channelId, productId, phone, openId } = this;
            if (!channelId) {
                return this.$toast("链接或二维码异常");
            }
            const data = { channelId, productId, phone, verifyCode };
            if (
                this.userAgent === "miniprogram" ||
                this.userAgent === "wechat"
            ) {
                data.openId = openId;
            }
            Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: "请求中",
            });
            request({
                url: "/tour-product/channel/vaildPhone",
                method: "POST",
                data: data,
            })
                .then((res) => {
					console.log(res)
                    Toast.clear();
                    if (res.data.code != "200") {
                        throw res.data.msg;
                    }
                    if (res.data.code == "200") {
                        that.orderId = res.data.data;
                        // 小程序
                        if (that.userAgent === "miniprogram") {
                            that.miniprogramPay();
                        }
                        // 微信客户端
                        if (that.userAgent === "wechat") {
                            that.wechatPay();
                        }
                        // 浏览器
                        if (that.userAgent === "h5") {
                            that.pay();
                        }
                    }
                })
                .catch((err) => {
                    Toast.clear();
                    that.$toast(err);
                });
        },

        // 小程序支付
        miniprogramPay() {
            const that = this;
            const { openId, orderId } = this;
            request({
                url: `/tour-product/weixin/pay?openId=${openId}&orderId=${orderId}&type=wxpay_notifyUrl&smart_appid=${this.appId}`,
                method: "GET",
            })
                .then((res) => {
                    if (res.data.code !== 200) {
                        throw res.data.msg;
                    }
                    if (res.data.code === 200) {
                        const { timeStamp, nonceStr, signType, paySign } =
                            res.data.data;
                        wx.miniProgram.navigateTo({
                            url: `/pages/wxPay/wxPay?timeStamp=${escape(
                                timeStamp
                            )}&nonceStr=${escape(nonceStr)}&package=${escape(
                                res.data.data.package
                            )}&signType=${escape(signType)}&paySign=${escape(
                                paySign
                            )}`,
                        });
                    }
                })
                .catch((err) => {
                    that.$toast(`miniprogram${err}`);
                });
        },
        // H5支付
        pay() {
            const that = this;
			console.log(this.orderId)
            const url = "/tour-product/weixin/h5/pay?orderId=" + this.orderId;
            request({
                url: url,
                methods: "GET",
            })
                .then((res) => {
					console.log(res)
					const path = `${process.env.VUE_APP_RDSIRECT_URL}/#/routergo?phone=${this.phone}`;
					console.log(path);
					const redirect_url = encodeURIComponent(path);
					console.log(redirect_url);
					const url = res.data.data + "&redirect_url=" + redirect_url;
					console.log(url);
                    if (res.data.code != "200") {
                        throw res.data.msg;
                    }
                    if (res.data.code == "200") {
                        console.log(res);
                        const path = `${process.env.VUE_APP_RDSIRECT_URL}/#/routergo?phone=${this.phone}`;
                        console.log(path);
                        const redirect_url = encodeURIComponent(path);
                        console.log(redirect_url);
                        const url =
                            res.data.data + "&redirect_url=" + redirect_url;
                        console.log(url);
                        window.location.replace(url);
                    }
                })
                .catch((err) => {
                    that.$toast(err);
                });
        },
        // 微信公众号支付
        wechatPay() {
            const that = this;
            const data = qs.stringify({
                openId: this.openId,
                orderId: this.orderId,
            });
            request({
                url: "/tour-product/weixin/gzhPay",
                method: "post",
                data: data,
            })
                .then((res) => {
                    if (res.data.code != "200") {
                        throw res.data.msg;
                    }
                    if (res.data.code == "200") {
                        WeixinJSBridge.invoke(
                            "getBrandWCPayRequest",
                            {
                                appId: process.env.VUE_APP_WXPUBLIC_ID, //公众号名称，由商户传入
                                timeStamp: res.data.data.timeStamp, //时间戳，自1970年以来的秒数
                                nonceStr: res.data.data.nonceStr, //随机串
                                package: res.data.data.package,
                                signType: res.data.data.signType, //微信签名方式
                                paySign: res.data.data.paySign, //微信签名
                            },
                            function (res) {
                                if (
                                    res.err_msg == "get_brand_wcpay_request:ok"
                                ) {
                                    // 使用以上方式判断前端返回,微信团队郑重提示：
                                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                                    that.$toast("支付成功");
                                    that.$router.push(
                                        `/routergo?phone=${that.phone}`
                                    );
                                } else if (
                                    res.err_msg ==
                                    "get_brand_wcpay_request:cancel"
                                ) {
                                    that.$toast("取消支付");
                                } else if (
                                    res.err_msg ==
                                    "get_brand_wcpay_request:fail"
                                ) {
                                    that.$toast("支付失败");
                                } else {
                                    that.$toast(res.err_msg);
                                }
                            }
                        );
                    }
                })
                .catch((err) => {
                    that.$toast(err);
                });
        },
        inputShow() {
            setTimeout(() => {
                this.$refs.inputShow.scrollIntoView();
                document.body.scrollTop = document.body.scrollHeight;
            }, 100);
        },
    },
};
</script>

<style scoped>
html,
body,
#app {
    height: 100%;
    margin: 0;
}
.h100 {
    height: 100px;
}
.container {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #fff;
}
.header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100px;
}
.content {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0px;
    width: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
}
.banner {
    width: 100%;
    height: 540px;
}
.tab-wrap {
    display: flex;
    position: relative;
    margin: -40px auto 0 auto;
    border-radius: 40px;
    width: 230px;
    height: 80px;
    font-size: 32px;
    font-weight: bold;
    line-height: 80px;
    text-align: center;
    background: #f7f7f7;
}
.tab-wrap .tab {
    width: 100%;
    height: 100%;
}
.tab-wrap .tab.active {
    border-radius: 40px;
    background-color: #ffd05e;
}
.tab-content {
    padding: 96px 40px 50px 40px;
    width: calc(100% - 80px);
}
.tab-content .form-item {
    margin-bottom: 40px;
    font-size: 28px;
}
.tab-content .form-item.message {
    display: flex;
    justify-content: space-between;
}
.tab-content .form-item .input {
    border-radius: 10px;
    padding: 0 40px;
    width: calc(100% - 80px);
    height: 88px;
    background: #f7f7f7;
}
.tab-content .form-item.message .input {
    width: calc(100% - 320px);
}
.tab-content .form-item .placeholderClass {
    font-weight: bold;
    line-height: 88px;
    color: #999;
}
.tab-content .form-item.message .button {
    border-radius: 10px;
    width: 220px;
    height: 88px;
    font-weight: bold;
    line-height: 88px;
    text-align: center;
    color: #fff;
    background: #ffd05e;
}

.tab-content .btn-v .button {
    border-radius: 44px;
    width: 100%;
    height: 88px;
    font-size: 32px;
    font-weight: bold;
    color: #fff;
    background: #ffd05e;
}
</style>
